<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-12>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        class="nevigater-link"
        @click="$router.push('/meeting')"
      >
        <span>จัดการห้องประชุม</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex
        shrink
        d-flex
        justify-start
        align-center
        style="color: #3e7662; font-weight: bold; font-size: 24px"
      >
        <span>แก้ไขวาระการประชุม</span>
      </v-flex>
    </v-layout>

    <!-- Form -->
    <v-card tile>
      <div style="background-color: #3e7662; padding: 20px">
        <v-switch
          v-model="isAutoSave"
          label="บันทึกอัตโนมัติ"
          dark
          @click="toggleAutoSave()"
        ></v-switch>
      </div>
      <v-divider
        style="background-color: #544a44; border-width: 2px"
      ></v-divider>
      <v-layout px-6 py-2 style="background-color: #fbf6f3">
        <v-flex style="color: #000000; text-align: left; font-weight: bold">
          <span>แก้ไขวาระการประชุม</span>
        </v-flex>
        <v-flex style="color: #000000; text-align: right; font-weight: bold">
          <span>RO 11_2563</span>
        </v-flex>
      </v-layout>
      <v-layout px-12 pt-6>
        <v-flex>
          <!-- blog 1 -->
          <v-layout>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold">ชื่อการประชุม</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <textfield-form
                hide-detail
                :model="form.meetingName"
                @update-data="updateData('meetingName', $event)"
              />
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>

          <!-- blog 2 -->
          <v-layout mt-8>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold">การประชุมครั้งที่</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <v-layout>
                <v-flex mr-4 xs6 d-flex justify-start align-center>
                  <textfield-form
                    hide-detail
                    :model="form.meetingNumber"
                    @update-data="updateData('meetingNumber', $event)"
                  />
                </v-flex>
                <v-flex xs6 d-flex justify-end align-center>
                  <v-layout>
                    <v-flex
                      xs2
                      mr-3
                      shrink
                      d-flex
                      justify-end
                      align-center
                      style="color: black; font-weight: bold"
                    >
                      <span><b>ปี</b></span>
                    </v-flex>
                    <v-flex d-flex align-center>
                      <v-select
                        class="style-chooser"
                        placeholder="Choose Year"
                        style="width: 100%"
                        :options="years"
                        v-model="form.meetingYear"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>

          <!-- blog 3 -->
          <v-layout mt-8>
            <v-flex pr-3 d-flex justify-end align-center xs3>
              <span style="font-weight: bold">วันที่</span>
            </v-flex>
            <v-flex xs6 d-flex justify-start align-center>
              <v-layout>
                <v-flex mr-4 xs6 d-flex justify-start align-center>
                  <DateInputForm
                    hide-detail
                    :model="meetingDate"
                    @update-data="updateDate('meetingDate', $event)"
                  />
                </v-flex>
                <v-flex xs6 shrink d-flex justify-end align-center>
                  <v-layout>
                    <v-flex
                      xs2
                      mr-3
                      d-flex
                      justify-end
                      align-center
                      style="color: black; font-weight: bold"
                    >
                      <span><b>เวลา</b></span>
                    </v-flex>
                    <v-flex shrink d-flex justify-start align-center>
                      <vue-timepicker
                        v-model="form.meetingTime"
                      ></vue-timepicker>
                    </v-flex>
                    <v-flex shrink d-flex align-center ml-2
                      ><span><b>น.</b></span></v-flex
                    >
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-spacer></v-spacer>
          </v-layout>

          <v-layout mb-6 mt-6 px-12>
            <v-flex
              shrink
              pr-4
              style="text-align: left"
              class="d-flex align-center"
            >
              <span style="font-weight: bold; font-size: 16px">
                ผู้เข้าร่วมการประชุม</span
              >
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink style="text-align: left">
              <v-btn
                dark
                style="width: 80px; background-color: #3e7662"
                @click="addReviewer('reviewers', 1)"
              >
                <v-icon>add</v-icon>
                <span class="font-weight-bold">เพิ่ม</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div v-for="(input, k) in reviewers" :key="k">
                <v-layout my-1 px-12>
                  <v-flex
                    shrink
                    ml-6
                    mr-4
                    pt-2
                    class="text-end font-weight-bold"
                  >
                    <span>คนที่ {{ k + 1 }}.</span>
                  </v-flex>
                  <v-flex xs5 class="field-select">
                    <text-autocomplete
                      id="reviewer"
                      placeholder="เลือก ชื่อผู้เข้าร่วมประชุม"
                      :items="reviewerList"
                      item-text="user_name"
                      itemValue="user_id"
                      :model="input.userID"
                      @update-data="updateData('reviewers', $event, k)"
                    />
                  </v-flex>
                  <v-flex ml-6 class="justify-end" style="text-align: right">
                    <v-btn
                      dark
                      style="background-color: #cc3d45; width: 80px"
                      @click="removeReviewer('reviewers', k)"
                      :disabled="reviewers.length <= 1"
                    >
                      <v-icon>remove</v-icon>
                      <span class="font-weight-bold">ลบ</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-layout mb-6 mt-6 px-12>
            <v-flex
              shrink
              pr-4
              style="text-align: left"
              class="d-flex align-center"
            >
              <span style="font-weight: bold; font-size: 16px">
                ผู้ไม่ได้เข้าประชุมเนื่องจากติดราชการ</span
              >
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink style="text-align: left">
              <v-btn
                dark
                style="width: 80px; background-color: #3e7662"
                @click="addReviewer('reviewersNotJoin', 1)"
              >
                <v-icon>add</v-icon>
                <span class="font-weight-bold">เพิ่ม</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div v-for="(input, k) in reviewersNotJoin" :key="k">
                <v-layout my-1 px-12>
                  <v-flex
                    shrink
                    ml-6
                    mr-4
                    pt-2
                    class="text-end font-weight-bold"
                  >
                    <span>คนที่ {{ k + 1 }}.</span>
                  </v-flex>
                  <v-flex xs5 class="field-select">
                    <text-autocomplete
                      id="notJoinReviewer"
                      placeholder="เลือก ชื่อผู้เข้าร่วมประชุม"
                      :items="reviewerList"
                      item-text="user_name"
                      itemValue="user_id"
                      :model="input.userID"
                      @update-data="updateData('reviewersNotJoin', $event, k)"
                    />
                  </v-flex>
                  <v-flex ml-6 class="justify-end" style="text-align: right">
                    <v-btn
                      dark
                      style="background-color: #cc3d45; width: 80px"
                      @click="removeReviewer('reviewersNotJoin', k)"
                    >
                      <v-icon>remove</v-icon>
                      <span class="font-weight-bold">ลบ</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-layout mb-6 mt-6 px-12>
            <v-flex
              shrink
              pr-4
              style="text-align: left"
              class="d-flex align-center"
            >
              <span style="font-weight: bold; font-size: 16px">
                ผู้เข้าร่วมสังเกตุการณ์</span
              >
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink style="text-align: left">
              <v-btn
                dark
                style="width: 80px; background-color: #3e7662"
                @click="addReviewer('reviewersObserver', 1)"
              >
                <v-icon>add</v-icon>
                <span class="font-weight-bold">เพิ่ม</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div v-for="(input, k) in reviewersObserver" :key="k">
                <v-layout my-1 px-12>
                  <v-flex
                    shrink
                    ml-6
                    mr-4
                    pt-2
                    class="text-end font-weight-bold"
                  >
                    <span>คนที่ {{ k + 1 }}.</span>
                  </v-flex>
                  <v-flex xs5 class="field-select">
                    <text-autocomplete
                      id="reviewersObserver"
                      placeholder="เลือก ชื่อผู้เข้าร่วมประชุม"
                      :items="reviewerList"
                      item-text="user_name"
                      itemValue="user_id"
                      :model="input.userID"
                      @update-data="updateData('reviewersObserver', $event, k)"
                    />
                  </v-flex>
                  <v-flex ml-6 class="justify-end" style="text-align: right">
                    <v-btn
                      dark
                      style="background-color: #cc3d45; width: 80px"
                      @click="removeReviewer('reviewersObserver', k)"
                    >
                      <v-icon>remove</v-icon>
                      <span class="font-weight-bold">ลบ</span> </v-btn
                    >
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <!-- blog 4 -->
          <v-layout mt-6 px-12>
            <v-flex mb-2 style="text-align: left">
              <span style="font-weight: bold"> สถานที่ </span>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-flex>
              <textarea-form
                :rows="2"
                :model="form.meetingPlace"
                @update-data="updateData('meetingPlace', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>

          <!-- blog 5 -->
          <v-layout mb-6 mt-6 px-12>
            <v-flex xs1 mb-2 style="text-align: left">
              <span style="font-weight: bold; color: #3e7662"> วาระที่ 1 </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left">
              <span style="font-weight: bold">
                เรื่องแจ้ง โดยประธานคณะอนุกรรมการฯ
              </span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink style="text-align: left">
              <v-btn
                dark
                style="width: 80px; background-color: #3e7662"
                @click="add('firstAgenda')"
              >
                <v-icon>add</v-icon>
                <span class="font-weight-bold">เพิ่ม</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <div v-for="(input, k) in firstAgenda" :key="k">
            <v-layout px-12>
              <v-flex
                shrink
                pt-2
                pr-4
                style="text-align: left"
                class="justify-end align-center d-flex"
              >
                <span style="font-weight: bold; font-size: 16px">ไฟล์</span>
              </v-flex>
              <v-flex xs3 class="align-center d-flex">
                <v-file-input
                  accept=".pdf"
                  prepend-icon=""
                  outlined
                  :id="'firstAgendaFile' + k"
                  v-model="input.file"
                  dense
                  placeholder="Choose file"
                  color="#3E7662"
                  item-color="#3E7662"
                  hide-details
                  @change="onUploadFileDynamic('firstAgendaFile', k, $event)"
                ></v-file-input>
              </v-flex>
              <v-flex xs1 col pl-4 style="text-align: left">
                <v-btn
                  color="#3E7662"
                  dark
                  @click="onHandleBtn('firstAgendaFile' + k)"
                >
                  <v-icon class="pr-3">cloud_download</v-icon>
                  <span>Upload</span>
                </v-btn>
                <v-btn
                  v-if="input.filePath"
                  :href="input.filePath"
                  class="white--text mt-2"
                  color="#DE7133"
                  target="_blank"
                >
                  <span class="text-capitalize">ดาวน์โหลด</span>
                </v-btn>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex class="d-flex justify-end">
                <v-btn
                  dark
                  style="background-color: #cc3d45; width: 80px"
                  @click="remove(k, 'firstAgenda')"
                >
                  <v-icon>remove</v-icon>
                  <span class="font-weight-bold">ลบ</span>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout px-12 mt-4>
              <v-flex>
                <textarea-form
                  :model="input.firstAgenda"
                  @update-data="updateData('firstAgenda', $event, k)"
                ></textarea-form>
              </v-flex>
            </v-layout>
          </div>

          <!-- blog 6 -->
          <v-layout px-12>
            <v-flex
              xs1
              mb-2
              style="text-align: left"
              class="align-center d-flex"
            >
              <span style="font-weight: bold; color: #3e7662"> วาระที่ 2 </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left" class="align-center d-flex">
              <span style="font-weight: bold"> ตรวจสอบองค์ประชุม </span>
            </v-flex>

            <v-flex
              shrink
              pt-2
              pr-4
              style="text-align: left"
              class="justify-end align-center d-flex"
            >
              <span style="font-weight: bold; font-size: 16px">ไฟล์</span>
            </v-flex>
            <v-flex xs3 class="align-center d-flex">
              <v-file-input
                accept=".pdf"
                prepend-icon=""
                outlined
                id="secondAgendaFile"
                v-model="secondAgendaFile"
                dense
                placeholder="Choose file"
                color="#3E7662"
                item-color="#3E7662"
                hide-details
                @change="onUploadFile('secondAgendaFile', $event)"
              ></v-file-input>
            </v-flex>
            <v-flex xs1 col pl-4 style="text-align: left">
              <v-btn
                color="#3E7662"
                dark
                @click="onHandleBtn('secondAgendaFile')"
              >
                <v-icon class="pr-3">cloud_download</v-icon>
                <span>Upload</span>
              </v-btn>
              <v-btn
                v-if="form.secondAgendaFilePath"
                :href="form.secondAgendaFilePath"
                class="white--text mt-2"
                color="#DE7133"
                target="_blank"
              >
                <span class="text-capitalize">ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout px-12 my-4>
            <v-flex>
              <table style="margin: auto">
                <tr>
                  <th class="text-left" style="width: 400px">
                    อัตราส่วน ชาย : หญิง
                  </th>
                  <th class="text-center" style="width: 150px">
                    {{ genderRatio.male }} : {{ genderRatio.female }}
                  </th>
                </tr>
                <tr>
                  <th class="text-left" style="width: 400px">
                    อัตราส่วน health science : non-health science
                  </th>
                  <th class="text-center" style="width: 150px">
                    {{ scientistRatio.scientist }} : {{ scientistRatio.non }}
                  </th>
                </tr>
                <tr>
                  <th class="text-left" style="width: 400px">
                    อัตราส่วน affiliated : non-affiliated
                  </th>
                  <th class="text-center" style="width: 150px">
                    {{ affiliationRatio.affiliation }} :
                    {{ affiliationRatio.non }}
                  </th>
                </tr>
              </table>
            </v-flex>
          </v-layout>
          <v-layout px-12 pb-12>
            <v-flex>
              <v-radio-group row v-model="form.secondAgendaResult">
                <v-radio value="1" label="รับทราบ" color="#3E7662"></v-radio>
                <v-radio value="0" label="ไม่รับทราบ" color="#3E7662"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <!-- blog 7 -->
          <v-layout px-12>
            <v-flex
              xs1
              mb-2
              style="text-align: left"
              class="align-center d-flex"
            >
              <span style="font-weight: bold; color: #3e7662"> วาระที่ 3 </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left" class="align-center d-flex">
              <span style="font-weight: bold">
                การมีผลประโยชน์ทับซ้อน (Conflict of interest)
              </span>
            </v-flex>

            <v-flex
              shrink
              pt-2
              pr-4
              style="text-align: left"
              class="justify-end align-center d-flex"
            >
              <span style="font-weight: bold; font-size: 16px">ไฟล์</span>
            </v-flex>
            <v-flex xs3 class="align-center d-flex">
              <v-file-input
                accept=".pdf"
                prepend-icon=""
                outlined
                id="thirdAgendaFile"
                v-model="thirdAgendaFile"
                dense
                placeholder="Choose file"
                color="#3E7662"
                item-color="#3E7662"
                hide-details
                @change="onUploadFile('thirdAgendaFile', $event)"
              ></v-file-input>
            </v-flex>
            <v-flex xs1 col pl-4 style="text-align: left">
              <v-btn
                color="#3E7662"
                dark
                @click="onHandleBtn('thirdAgendaFile')"
              >
                <v-icon class="pr-3">cloud_download</v-icon>
                <span>Upload</span>
              </v-btn>
              <v-btn
                v-if="form.thirdAgendaFilePath"
                :href="form.thirdAgendaFilePath"
                class="white--text mt-2"
                color="#DE7133"
                target="_blank"
              >
                <span class="text-capitalize">ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout px-12 mt-4>
            <v-flex>
              <textarea-form
                :model="form.thirdAgenda"
                @update-data="updateData('thirdAgenda', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>
          <v-layout px-12 pb-12>
            <v-flex>
              <v-radio-group row v-model="form.thirdAgendaResult">
                <v-radio value="1" label="รับทราบ" color="#3E7662"></v-radio>
                <v-radio value="0" label="ไม่รับทราบ" color="#3E7662"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <!-- blog 8 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12 mb-6>
            <v-flex shrink mb-2 style="text-align: left">
              <span style="font-weight: bold; color: #3e7662">วาระที่ 4 </span>
              <span style="font-weight: bold">รับรองวาระการประชุม</span>
            </v-flex>
            <v-spacer></v-spacer>
            <!--<v-flex style="text-align: right">-->
            <!--<v-btn color="#3E7662" dark @click="add('fourthAgenda')">-->
            <!--<v-icon>add</v-icon>-->
            <!--</v-btn>-->
            <!--</v-flex>-->
          </v-layout>
          <v-layout px-12>
            <v-radio-group row v-model="form.fourthAgendaResult">
              <v-radio value="1" label="รับรอง" color="#3E7662"></v-radio>
              <v-radio value="2" label="ไม่รับรอง" color="#3E7662"></v-radio>
            </v-radio-group>
          </v-layout>
          <!--<div v-for="(input, k) in fourthAgenda" :key="'a' + k">-->
          <!--<v-card class="mx-12 mt-4">-->
          <!--<div class="text-end">-->
          <!--<v-icon-->
          <!--:disabled="fourthAgenda.length <= 1"-->
          <!--color="#CC3D45"-->
          <!--class="clear-card"-->
          <!--@click="remove(k, 'fourthAgenda')"-->
          <!--&gt;-->
          <!--clear-->
          <!--</v-icon>-->
          <!--</div>-->
          <!--&lt;!&ndash; row 2 &ndash;&gt;-->
          <!--<v-layout px-12>-->
          <!--<v-flex ml-12 class="justify-start align-center d-flex">-->
          <!--<v-radio-group-->
          <!--hide-details-->
          <!--v-model="input.hasFourthAgenda"-->
          <!--row-->
          <!--&gt;-->
          <!--<v-radio-->
          <!--color="#3E7662"-->
          <!--style="padding-right: 60px"-->
          <!--label="มี"-->
          <!--value="1"-->
          <!--&gt;</v-radio>-->
          <!--<v-radio-->
          <!--@click.native="clearRedio('hasFourthAgenda', k)"-->
          <!--color="#3E7662"-->
          <!--label="ไม่มี"-->
          <!--value="0"-->
          <!--&gt;</v-radio>-->
          <!--</v-radio-group>-->
          <!--</v-flex>-->
          <!--<v-flex shrink mr-3 class="justify-end align-center d-flex">-->
          <!--<span style="color: #CC3D45;font-weight: bold"-->
          <!--&gt;*ระบุหัวข้อการวิจัย</span-->
          <!--&gt;-->
          <!--</v-flex>-->
          <!--<v-flex xs4 class="justify-end align-center d-flex">-->
          <!--<text-autocomplete-->
          <!--:disabled="input.hasFourthAgenda === '0'"-->
          <!--:items="researchList"-->
          <!--hide-details-->
          <!--item-text="name"-->
          <!--item-value="id"-->
          <!--:model="input.researchFourthAgenda"-->
          <!--@update-data="-->
          <!--updateDataFourthAgenda('researchFourthAgenda', k, $event)-->
          <!--"-->
          <!--/>-->
          <!--</v-flex>-->
          <!--</v-layout>-->

          <!--<v-layout px-12 my-6>-->
          <!--<v-spacer></v-spacer>-->
          <!--<v-flex xs6>-->
          <!--<v-layout>-->
          <!--<v-flex-->
          <!--shrink-->
          <!--pt-2-->
          <!--pr-4-->
          <!--style="text-align: left;"-->
          <!--class="justify-end align-center d-flex"-->
          <!--&gt;-->
          <!--<span style="font-weight: bold;font-size: 16px;"-->
          <!--&gt;ไฟล์</span-->
          <!--&gt;-->
          <!--</v-flex>-->
          <!--<v-flex xs8 class="align-center d-flex">-->
          <!--<v-file-input-->
          <!--:disabled="input.hasFourthAgenda === '0'"-->
          <!--accept=".pdf"-->
          <!--prepend-icon=""-->
          <!--:id="'fourthAgendaFile' + k"-->
          <!--:model="input.file"-->
          <!--outlined-->
          <!--dense-->
          <!--placeholder="Choose file"-->
          <!--:background-color="-->
          <!--input.hasFourthAgenda === '0'-->
          <!--? '#E9E9E9'-->
          <!--: '#FBF6F3'-->
          <!--"-->
          <!--color="#3E7662"-->
          <!--item-color="#3E7662"-->
          <!--@change="-->
          <!--onUploadFileDynamic('fourthAgenda', k, $event)-->
          <!--"-->
          <!--hide-details-->
          <!--&gt;</v-file-input>-->
          <!--</v-flex>-->
          <!--<v-flex col pl-4 style="text-align: left">-->
          <!--<v-btn-->
          <!--:disabled="input.hasFourthAgenda === '0'"-->
          <!--color="#3E7662"-->
          <!--:dark="input.hasFourthAgenda !== '0'"-->
          <!--@click="onHandleBtn('fourthAgendaFile' + k)"-->
          <!--&gt;-->
          <!--<v-icon class="pr-3">cloud_download</v-icon>-->
          <!--<span>Upload</span>-->
          <!--</v-btn>-->
          <!--<v-btn v-if="input.filePath" :href="input.filePath" class="white&#45;&#45;text mt-2" color="#DE7133"  target="_blank">-->
          <!--<span class="text-capitalize">ดาวน์โหลด</span>-->
          <!--</v-btn>-->
          <!--</v-flex>-->
          <!--</v-layout>-->
          <!--</v-flex>-->
          <!--</v-layout>-->
          <!--&lt;!&ndash; row 3 &ndash;&gt;-->
          <!--<v-layout mt-4 px-12>-->
          <!--<v-flex>-->
          <!--<textarea-form-->
          <!--:disabled="input.hasFourthAgenda === '0'"-->
          <!--:background-color="-->
          <!--input.hasFourthAgenda === '0' ? '#E9E9E9' : '#FBF6F3'-->
          <!--"-->
          <!--:rows="7"-->
          <!--:model="input.fourthAgendaDescription"-->
          <!--@update-data="-->
          <!--updateDataFourthAgenda(-->
          <!--'fourthAgendaDescription',-->
          <!--k,-->
          <!--$event-->
          <!--)-->
          <!--"-->
          <!--&gt;</textarea-form>-->
          <!--</v-flex>-->
          <!--</v-layout>-->

          <!--<v-layout px-12 pb-12>-->
          <!--<v-flex>-->
          <!--<v-radio-group row v-model="input.result">-->
          <!--<v-radio value="1" label="รับรอง" color="#3E7662"></v-radio>-->
          <!--<v-radio value="0" label="ไม่รับรอง" color="#3E7662"></v-radio>-->
          <!--</v-radio-group>-->
          <!--</v-flex>-->
          <!--</v-layout>-->
          <!--</v-card>-->
          <!--</div>-->

          <!-- blog 9 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex
              shrink
              mb-2
              style="text-align: left; font-weight: bold"
              class="d-flex align-center"
            >
              <span style="color: #3e7662"
                >วาระที่ 5
                <span style="color: black"
                  >รับรองรายงานการประชุมครั้งที่ผ่านมา</span
                ></span
              >
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex style="text-align: right" class="align-center">
              <v-btn color="#3E7662" dark @click="add('fifthAgenda')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <div v-for="(input, i) in fifthAgenda" :key="'b' + i">
            <v-layout px-12 py-6 justify="center">
              <v-flex xs6>
                <text-autocomplete
                  placeholder="รอบการประชุม"
                  :items="meetingList"
                  item-text="name"
                  itemValue="id"
                  :model="input.meetingID"
                  hide-details
                  @update-data="updateDataFifthAgenda('meetingID', i, $event)"
                />
              </v-flex>
              <v-flex
                xs4
                pr-4
                style="text-align: left"
                class="justify-end d-flex"
                pt-2
              >
                <span style="font-weight: bold; font-size: 16px">ไฟล์</span>
              </v-flex>
              <v-flex xs3 class="d-flex">
                <v-file-input
                  accept=".pdf"
                  prepend-icon=""
                  :id="'fifthAgendaFile' + i"
                  :model="input.file"
                  outlined
                  dense
                  placeholder="Choose file"
                  color="#3E7662"
                  item-color="#3E7662"
                  @change="onUploadFileDynamic('fifthAgenda', i, $event)"
                  hide-details
                ></v-file-input>
              </v-flex>
              <v-flex col pl-4 mt-n3 style="text-align: left">
                <v-btn
                  dark
                  color="#3E7662"
                  @click="onHandleBtn('fifthAgendaFile' + i)"
                >
                  <v-icon class="pr-3">cloud_download</v-icon>
                  <span>Upload</span>
                </v-btn>
                <v-btn
                  dark
                  v-if="input.filePath"
                  :href="input.filePath"
                  class="white--text mt-2"
                  color="#DE7133"
                  target="_blank"
                >
                  <span class="text-capitalize">ดาวน์โหลด</span>
                </v-btn>
              </v-flex>
              <v-flex ml-6 class="justify-end" style="text-align: right">
                <v-btn
                  dark
                  style="background-color: #cc3d45; width: 80px"
                  @click="remove(i, 'fifthAgenda')"
                >
                  <v-icon>remove</v-icon>
                  <span class="font-weight-bold">ลบ</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </div>

          <v-layout mt-12 px-12>
            <v-flex
              shrink
              mb-2
              style="text-align: left"
              class="d-flex align-center"
            >
              <span style="font-weight: bold; color: #3e7662"> วาระที่ 6 </span>
            </v-flex>
            <v-flex
              mb-2
              style="text-align: left"
              class="d-flex align-center pl-3"
            >
              <span style="font-weight: bold"> เรื่องที่จะพิจารณา </span>
            </v-flex>
          </v-layout>
          <!-- blog 8 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex
              shrink
              mb-2
              style="text-align: left"
              class="d-flex align-center"
            >
              <span style="font-weight: bold; color: #3e7662"> 6.1 </span>
            </v-flex>
            <v-flex
              mb-2
              style="text-align: left"
              class="d-flex align-center pl-3"
            >
              <span style="font-weight: bold">
                รายงานผลการพิจารณาเพื่อรับรองในที่ประชุม
              </span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex style="text-align: right">
              <v-btn color="#3E7662" dark @click="add('sixthAgenda')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <div v-for="(input, k) in sixthAgenda" :key="'c' + k">
            <v-card class="mx-12 mt-4">
              <div class="text-end">
                <v-icon
                  :disabled="sixthAgenda.length <= 1"
                  color="#CC3D45"
                  class="clear-card"
                  @click="remove(k, 'sixthAgenda')"
                >
                  clear
                </v-icon>
              </div>
              <v-layout>
                <v-flex shrink>
                  <p class="pt-2 pl-4">เรื่อง</p>
                </v-flex>
                <v-flex xs6 px-12 pb-6>
                  <textfield-form
                    hide-detail
                    :model="input.title"
                    @update-data="updateDataSixthAgenda('title', k, $event)"
                  />
                </v-flex>
              </v-layout>
              <!-- row 2 -->
              <v-layout px-12>
                <v-flex ml-12 justify-start align-center d-flex>
                  <v-radio-group
                    hide-details
                    v-model="input.hasSixthAgenda"
                    row
                  >
                    <v-radio
                      color="#3E7662"
                      style="padding-right: 60px"
                      label="มี"
                      value="1"
                    ></v-radio>
                    <v-radio
                      @click.native="clearRedio('hasSixthAgenda', k)"
                      color="#3E7662"
                      label="ไม่มี"
                      value="0"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex shrink mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold">ระบุหัวข้อการวิจัย</span>
                </v-flex>
                <v-flex xs4 justify-end align-center d-flex>
                  <text-autocomplete
                    :disabled="input.hasSixthAgenda === '0'"
                    :items="researchList"
                    item-value="id"
                    hide-details
                    item-text="name"
                    :model="input.researchSixthAgenda"
                    @update-data="
                      updateDataSixthAgenda('researchSixthAgenda', k, $event)
                    "
                  />
                </v-flex>
              </v-layout>
              <v-layout px-12 my-6>
                <v-spacer></v-spacer>
                <v-flex xs6>
                  <v-layout>
                    <v-flex
                      shrink
                      pt-2
                      pr-4
                      style="text-align: left"
                      class="justify-end align-center d-flex"
                    >
                      <span style="font-weight: bold; font-size: 16px"
                        >ไฟล์</span
                      >
                    </v-flex>
                    <v-flex xs8 class="align-center d-flex">
                      <v-file-input
                        :disabled="input.hasSixthAgenda === '0'"
                        accept=".pdf"
                        prepend-icon=""
                        :id="'sixthAgendaFile' + k"
                        :model="input.file"
                        outlined
                        dense
                        placeholder="Choose file"
                        :background-color="
                          input.hasSixthAgenda === '0' ? '#E9E9E9' : '#FBF6F3'
                        "
                        color="#3E7662"
                        item-color="#3E7662"
                        @change="onUploadFileDynamic('sixthAgenda', k, $event)"
                        hide-details
                      ></v-file-input>
                    </v-flex>
                    <v-flex col pl-4 style="text-align: left">
                      <v-btn
                        :disabled="input.hasSixthAgenda === '0'"
                        color="#3E7662"
                        :dark="input.hasSixthAgenda !== '0'"
                        @click="onHandleBtn('sixthAgendaFile' + k)"
                      >
                        <v-icon class="pr-3">cloud_download</v-icon>
                        <span>Upload</span>
                      </v-btn>

                      <v-btn
                        v-if="input.filePath"
                        :href="input.filePath"
                        class="white--text mt-2"
                        color="#DE7133"
                        target="_blank"
                      >
                        <span class="text-capitalize">ดาวน์โหลด</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <!-- row 3 -->
              <v-layout mt-4 px-12>
                <v-flex v-if="input.researchSixthAgenda" pb-6>
                  <a
                    style="color: #3e7662"
                    target="_blank"
                    :href="'/view-research?id=' + sixthAgendaData[k].id"
                    >รหัสโครงการวิจัย : {{ sixthAgendaData[k].researchCode }}</a
                  ><br />
                  <span
                    >ชื่อโครงการวิจัย :
                    {{ sixthAgendaData[k].thResearchName }}</span
                  ><br />
                  <span
                    >ผู้วิจัยหลัก :
                    {{ sixthAgendaData[k].mainResearcherThName }}</span
                  >
                </v-flex>
              </v-layout>
            </v-card>
          </div>
          <!-- blog 9 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex
              shrink
              mb-2
              style="text-align: left"
              class="d-flex align-center"
            >
              <span style="font-weight: bold; color: #3e7662"> 6.2 </span>
            </v-flex>
            <v-flex
              mb-2
              style="text-align: left"
              class="d-flex align-center pl-3"
            >
              <span style="font-weight: bold">
                การพิจารณาโครงร่างการวิจัย
              </span>
            </v-flex>
          </v-layout>
          <v-layout mt-12 px-12>
            <v-flex
              shrink
              mb-2
              style="text-align: left"
              class="d-flex align-center"
            >
              <span style="font-weight: bold; color: #3e7662"> 6.2.1 </span>
            </v-flex>
            <v-flex
              mb-2
              style="text-align: left"
              class="d-flex align-center pl-3"
            >
              <span style="font-weight: bold">
                โครงร่างการวิจัยที่ขอรับรองครั้งแรก (Protocol for Initial
                Review)
              </span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex style="text-align: right" v-if="form.hasSeventh === '1'">
              <v-btn color="#3E7662" dark @click="add('seventhAgenda')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-radio-group hide-details v-model="form.hasSeventh" row>
              <v-flex>
                <v-radio
                  color="#3E7662"
                  style="padding-right: 60px"
                  label="มี"
                  value="1"
                ></v-radio>
              </v-flex>
              <v-flex>
                <v-radio
                  @click.native="clearRedio('hasSeventh')"
                  color="#3E7662"
                  label="ไม่มี"
                  value="0"
                ></v-radio>
              </v-flex>
              <v-flex shrink ml-4 v-if="form.hasSeventh === '1'">
                <p>จำนวน {{ seventhAgenda.length }} โครงการ</p>
              </v-flex>
            </v-radio-group>
          </v-layout>
          <div v-if="form.hasSeventh === '1'">
            <div v-for="(input, k) in seventhAgenda" :key="'e' + k">
              <v-card class="mx-12 mt-4">
                <div class="text-end">
                  <v-icon
                    :disabled="seventhAgenda.length <= 1"
                    color="#CC3D45"
                    class="clear-card"
                    @click="remove(k, 'seventhAgenda')"
                  >
                    clear
                  </v-icon>
                </div>
                <!-- row 2 -->
                <v-layout px-12>
                  <v-flex ml-12 justify-start align-center d-flex> </v-flex>
                  <v-flex shrink mr-3 justify-end align-center d-flex>
                    <span style="color: #cc3d45; font-weight: bold"
                      >*ระบุหัวข้อการวิจัย</span
                    >
                  </v-flex>
                  <v-flex xs4 justify-end align-center d-flex>
                    <text-autocomplete
                      :items="researchList"
                      item-value="id"
                      hide-details
                      item-text="name"
                      :model="input.researchSeventhAgenda"
                      @update-data="
                        updateDataSeventhAgenda(
                          'researchSeventhAgenda',
                          k,
                          $event
                        )
                      "
                    />
                  </v-flex>
                </v-layout>

                <v-layout px-12 my-6>
                  <v-spacer></v-spacer>
                  <v-flex xs6>
                    <v-layout>
                      <v-flex
                        shrink
                        pt-2
                        pr-4
                        style="text-align: left"
                        class="align-center justify-end d-flex"
                      >
                        <span style="font-weight: bold; font-size: 16px"
                          >ไฟล์</span
                        >
                      </v-flex>
                      <v-flex xs8 class="align-center d-flex">
                        <v-file-input
                          accept=".pdf"
                          prepend-icon=""
                          :id="'seventhAgendaFile' + k"
                          :model="input.file"
                          outlined
                          dense
                          placeholder="Choose file"
                          background-color="#FBF6F3"
                          color="#3E7662"
                          item-color="#3E7662"
                          @change="
                            onUploadFileDynamic('seventhAgenda', k, $event)
                          "
                          hide-details
                        ></v-file-input>
                      </v-flex>
                      <v-flex shrink pl-4 style="text-align: left">
                        <v-btn
                          color="#3E7662"
                          dark
                          @click="onHandleBtn('seventhAgendaFile' + k)"
                        >
                          <v-icon class="pr-3">cloud_download</v-icon>
                          <span>Upload</span>
                        </v-btn>
                        <v-btn
                          v-if="input.filePath"
                          :href="input.filePath"
                          class="white--text mt-2"
                          color="#DE7133"
                          target="_blank"
                        >
                          <span class="text-capitalize">ดาวน์โหลด</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- row 3 -->

                <v-layout mt-4 px-12>
                  <v-flex v-if="input.researchSeventhAgenda" pb-6>
                    <a
                      style="color: #3e7662"
                      target="_blank"
                      :href="'/view-research?id=' + seventhAgendaData[k].id"
                      >รหัสโครงการวิจัย :
                      {{ seventhAgendaData[k].researchCode }}</a
                    ><br />
                    <span
                      >ชื่อโครงการวิจัย :
                      {{ seventhAgendaData[k].thResearchName }}</span
                    ><br />
                    <span
                      >ผู้วิจัยหลัก :
                      {{ seventhAgendaData[k].mainResearcherThName }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </div>
          </div>
          <!-- blog 10 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex shrink mb-2 style="text-align: left">
              <span style="font-weight: bold; color: #3e7662"> 6.2.2 </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left">
              <span style="font-weight: bold" class="pl-3">
                โครงร่างการวิจัยที่ปรับแก้ไขและนําเข้าพิจารณาใหม่
                (Re-Submission)
              </span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex style="text-align: right">
              <v-btn
                v-if="form.hasEighth === '1'"
                color="#3E7662"
                dark
                @click="add('eighthAgenda')"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-radio-group hide-details v-model="form.hasEighth" row>
              <v-flex>
                <v-radio
                  color="#3E7662"
                  style="padding-right: 60px"
                  label="มี"
                  value="1"
                ></v-radio>
              </v-flex>
              <v-flex>
                <v-radio
                  @click.native="clearRedio('hasEighth')"
                  color="#3E7662"
                  label="ไม่มี"
                  value="0"
                ></v-radio>
              </v-flex>
              <v-flex shrink ml-4 v-if="form.hasEighth === '1'">
                <p>จำนวน {{ eighthAgenda.length }} โครงการ</p>
              </v-flex>
            </v-radio-group>
          </v-layout>
          <div v-if="form.hasEighth === '1'">
            <div v-for="(input, k) in eighthAgenda" :key="'f' + k">
              <v-card class="mx-12 mt-4">
                <div class="text-end">
                  <v-icon
                    :disabled="eighthAgenda.length <= 1"
                    color="#CC3D45"
                    class="clear-card"
                    @click="remove(k, 'eighthAgenda')"
                  >
                    clear
                  </v-icon>
                </div>
                <!-- row 2 -->
                <v-layout px-12>
                  <v-flex ml-12 justify-start align-center d-flex> </v-flex>
                  <v-flex shrink mr-3 justify-end align-center d-flex>
                    <span style="color: #cc3d45; font-weight: bold"
                      >*ระบุหัวข้อการวิจัย</span
                    >
                  </v-flex>
                  <v-flex xs4 justify-end align-center d-flex>
                    <text-autocomplete
                      :items="researchList"
                      item-value="id"
                      hide-details
                      item-text="name"
                      :model="input.researchEighthAgenda"
                      @update-data="
                        updateDataEighthAgenda(
                          'researchEighthAgenda',
                          k,
                          $event
                        )
                      "
                    />
                  </v-flex>
                </v-layout>

                <v-layout px-12 my-6>
                  <v-spacer></v-spacer>
                  <v-flex xs6>
                    <v-layout>
                      <v-flex
                        shrink
                        pt-2
                        pr-4
                        style="text-align: left"
                        class="align-center justify-end d-flex"
                      >
                        <span style="font-weight: bold; font-size: 16px"
                          >ไฟล์</span
                        >
                      </v-flex>
                      <v-flex xs8 class="align-center d-flex">
                        <v-file-input
                          accept=".pdf"
                          prepend-icon=""
                          :id="'eighthAgendaFile' + k"
                          :model="input.file"
                          outlined
                          dense
                          placeholder="Choose file"
                          background-color="#FBF6F3"
                          color="#3E7662"
                          item-color="#3E7662"
                          @change="
                            onUploadFileDynamic('eighthAgenda', k, $event)
                          "
                          hide-details
                        ></v-file-input>
                      </v-flex>
                      <v-flex shrink pl-4 style="text-align: left">
                        <v-btn
                          color="#3E7662"
                          dark
                          @click="onHandleBtn('eighthAgendaFile' + k)"
                        >
                          <v-icon class="pr-3">cloud_download</v-icon>
                          <span>Upload</span>
                        </v-btn>
                        <v-btn
                          v-if="input.filePath"
                          :href="input.filePath"
                          class="white--text mt-2"
                          color="#DE7133"
                          target="_blank"
                        >
                          <span class="text-capitalize">ดาวน์โหลด</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- row 3 -->

                <v-layout mt-4 px-12>
                  <v-flex v-if="input.researchEighthAgenda" pb-6>
                    <a
                      style="color: #3e7662"
                      target="_blank"
                      :href="'/view-research?id=' + eighthAgendaData[k].id"
                      >รหัสโครงการวิจัย :
                      {{ eighthAgendaData[k].researchCode }}</a
                    ><br />
                    <span
                      >ชื่อโครงการวิจัย :
                      {{ eighthAgendaData[k].thResearchName }}</span
                    ><br />
                    <span
                      >ผู้วิจัยหลัก :
                      {{ eighthAgendaData[k].mainResearcherThName }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </div>
          </div>

          <!-- blog 11 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex shrink mb-2 style="text-align: left">
              <span style="font-weight: bold; color: #3e7662"> 6.2.3 </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left" class="pl-3">
              <span style="font-weight: bold">
                โครงร่างการวิจัยที่รับการประเมินแบบ Expedited
                และอนุกรรมการฯผู้ทบทวนขอ นําเข้าพิจารณาในที่ประชุม full board
              </span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex style="text-align: right">
              <v-btn
                v-if="form.hasNinth === '1'"
                color="#3E7662"
                dark
                @click="add('ninthAgenda')"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout px-12>
            <v-radio-group hide-details v-model="form.hasNinth" row>
              <v-flex>
                <v-radio
                  color="#3E7662"
                  style="padding-right: 60px"
                  label="มี"
                  value="1"
                ></v-radio>
              </v-flex>
              <v-flex>
                <v-radio
                  @click.native="clearRedio('hasNinth')"
                  color="#3E7662"
                  label="ไม่มี"
                  value="0"
                ></v-radio>
              </v-flex>
              <v-flex shrink ml-4 v-if="form.hasNinth === '1'">
                <p>จำนวน {{ ninthAgenda.length }} โครงการ</p>
              </v-flex>
            </v-radio-group>
          </v-layout>
          <div v-if="form.hasNinth === '1'">
            <div v-for="(input, k) in ninthAgenda" :key="'g' + k">
              <v-card class="mx-12 mt-4">
                <div class="text-end">
                  <v-icon
                    :disabled="ninthAgenda.length <= 1"
                    color="#CC3D45"
                    class="clear-card"
                    @click="remove(k, 'ninthAgenda')"
                  >
                    clear
                  </v-icon>
                </div>
                <!-- row 2 -->
                <v-layout px-12>
                  <v-flex ml-12 justify-start align-center d-flex> </v-flex>
                  <v-flex shrink mr-3 justify-end align-center d-flex>
                    <span style="color: #cc3d45; font-weight: bold"
                      >*ระบุหัวข้อการวิจัย</span
                    >
                  </v-flex>
                  <v-flex xs4 justify-end align-center d-flex>
                    <text-autocomplete
                      :items="researchList"
                      item-value="id"
                      hide-details
                      item-text="name"
                      :model="input.researchNinthAgenda"
                      @update-data="
                        updateDataNinthAgenda('researchNinthAgenda', k, $event)
                      "
                    />
                  </v-flex>
                </v-layout>

                <v-layout px-12 my-6>
                  <v-spacer></v-spacer>
                  <v-flex xs6>
                    <v-layout>
                      <v-flex
                        shrink
                        pt-2
                        pr-4
                        style="text-align: left"
                        class="align-center justify-end d-flex"
                      >
                        <span style="font-weight: bold; font-size: 16px"
                          >ไฟล์</span
                        >
                      </v-flex>
                      <v-flex xs8 class="align-center d-flex">
                        <v-file-input
                          accept=".pdf"
                          prepend-icon=""
                          :id="'ninthAgendaFile' + k"
                          :model="input.file"
                          outlined
                          dense
                          placeholder="Choose file"
                          background-color="#FBF6F3"
                          color="#3E7662"
                          item-color="#3E7662"
                          @change="
                            onUploadFileDynamic('ninthAgenda', k, $event)
                          "
                          hide-details
                        ></v-file-input>
                      </v-flex>
                      <v-flex shrink pl-4 style="text-align: left">
                        <v-btn
                          color="#3E7662"
                          dark
                          @click="onHandleBtn('ninthAgendaFile' + k)"
                        >
                          <v-icon class="pr-3">cloud_download</v-icon>
                          <span>Upload</span>
                        </v-btn>
                        <v-btn
                          v-if="input.filePath"
                          :href="input.filePath"
                          class="white--text mt-2"
                          color="#DE7133"
                          target="_blank"
                        >
                          <span class="text-capitalize">ดาวน์โหลด</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- row 3 -->

                <v-layout mt-4 px-12>
                  <v-flex v-if="input.researchNinthAgenda" pb-6>
                    <a
                      style="color: #3e7662"
                      target="_blank"
                      :href="'/view-research?id=' + ninthAgendaData[k].id"
                      >รหัสโครงการวิจัย :
                      {{ ninthAgendaData[k].researchCode }}</a
                    ><br />
                    <span
                      >ชื่อโครงการวิจัย :
                      {{ ninthAgendaData[k].thResearchName }}</span
                    ><br />
                    <span
                      >ผู้วิจัยหลัก :
                      {{ ninthAgendaData[k].mainResearcherThName }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </div>
          </div>

          <!-- blog 13 -->
          <!-- row 1 -->
          <v-layout mt-12 px-12>
            <v-flex xs1 mb-2 style="text-align: left">
              <span style="font-weight: bold; color: #3e7662"> วาระที่ 7 </span>
            </v-flex>
            <v-flex mb-2 style="text-align: left">
              <span style="font-weight: bold"> เรื่องอื่นๆ </span>
            </v-flex>

            <v-flex
              shrink
              pt-2
              pr-4
              style="text-align: left"
              class="justify-end align-center d-flex"
            >
              <span style="font-weight: bold; font-size: 16px">ไฟล์</span>
            </v-flex>
            <v-flex xs3 class="align-center d-flex">
              <v-file-input
                accept=".pdf"
                prepend-icon=""
                outlined
                id="eleventhAgendaFile"
                v-model="eleventhAgendaFile"
                dense
                placeholder="Choose file"
                color="#3E7662"
                item-color="#3E7662"
                hide-details
                @change="onUploadFile('eleventhAgendaFile', $event)"
              ></v-file-input>
            </v-flex>
            <v-flex xs1 col pl-4 style="text-align: left">
              <v-btn
                color="#3E7662"
                dark
                @click="onHandleBtn('eleventhAgendaFile')"
              >
                <v-icon class="pr-3">cloud_download</v-icon>
                <span>Upload</span>
              </v-btn>
              <v-btn
                v-if="form.eleventhAgendaFilePath"
                :href="form.eleventhAgendaFilePath"
                class="white--text mt-2"
                color="#DE7133"
                target="_blank"
              >
                <span class="text-capitalize">ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <!-- row 2 -->
          <v-layout mt-4 px-12>
            <v-flex>
              <textarea-form
                background-color="#FBF6F3"
                :rows="7"
                :model="form.eleventhAgenda"
                @update-data="updateData('eleventhAgenda', $event)"
              ></textarea-form>
            </v-flex>
          </v-layout>
          <!--End Time-->
          <v-layout px-12>
            <v-flex
              shrink
              d-flex
              mr-2
              justify-start
              align-center
              style="color: black; font-weight: bold"
            >
              <span><b>ปิดการประชุม เวลา</b></span>
            </v-flex>

            <v-flex shrink d-flex justify-start align-center>
              <vue-timepicker v-model="form.meetingEndTime"></vue-timepicker>
            </v-flex>
            <v-flex shrink d-flex align-center ml-2
              ><span><b>น.</b></span></v-flex
            >
          </v-layout>
          <!-- blog 13 -->
          <v-layout mt-8 px-12>
            <v-flex
              shrink
              d-flex
              justify-start
              align-center
              style="text-align: left; font-weight: bold"
            >
              <span>ผลการพิจารณาโครงร่างการวิจัย</span>
            </v-flex>
          </v-layout>
          <v-layout px-12 mt-4>
            <v-flex
              d-flex
              justify-start
              align-center
              style="text-align: left; font-weight: bold"
            >
              <v-file-input
                prepend-icon=""
                hide-details
                v-model="form.result"
                label="กรุณาเลือกไฟล์ PDF"
                outlined
                dense
                color="#3E7662"
                clearable
                background-color="#FBF6F3"
                show-size
                append-icon="attach_file"
              ></v-file-input>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout style="padding-left: 100px" mt-1 v-if="result">
        <v-flex style="text-align: left; font-size: 14px">
          <span>ไฟล์: </span>
          <a style="color: #cc3d45" @click="openPDF">{{ result }}</a>
        </v-flex>
      </v-layout>

      <v-divider
        class="mt-12"
        style="background-color: #544a44; border-width: 2px"
      ></v-divider>
    </v-card>

    <!-- Button -->
    <v-layout mt-12>
      <!--            <v-flex mr-8 ml-12 d-flex justify-start>-->
      <!--                <v-btn dark color="#CC3D45" @click="deleteData">-->
      <!--                    <span style="font-weight: bold">ลบข้อมูล</span>-->
      <!--                </v-btn>-->
      <!--            </v-flex>-->
      <v-flex mr-8 d-flex justify-end>
        <v-btn color="#FFFFFF" @click="$router.push('/meeting')">
          <span style="color: #3e7662; font-weight: bold">ย้อนกลับ</span>
        </v-btn>
      </v-flex>
      <v-flex shrink d-flex justify-end>
        <v-btn color="#3E7662" dark @click="update(1)">
          <span style="font-weight: bold">บันทึก</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import vSelect from "vue-select";
import { mapState, mapActions } from "vuex";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import Timeselector from "vue-timeselector";

import TextareaForm from "../../components/input/TextareaForm";
import DateInputForm from "../../components/input/DateInputForm";
import FileInputForm from "../../components/input/FileInputForm";
import TextfieldForm from "../../components/input/TextfieldForm";
import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextAutocomplete from "../../components/input/TextAutocomplete";

export default {
  name: "CreateMeeting",
  components: {
    TextareaForm,
    TextfieldForm,
    VueEditor,
    DateInputForm,
    Loading,
    FileInputForm,
    Timeselector,
    VueTimepicker,
    vSelect,
    TextAutocomplete,
  },
  computed: {
    years() {
      let year = new Date().getFullYear();
      return Array.from(
        { length: year - 1900 },
        (value, index) => 1901 + 543 + index
      ).reverse();
    },
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    id: "",
    isLoading: false,
    refreshIntervalID: null,
    isAutoSave: false,
    fullPage: true,
    result: "",
    pathResult: "",
    form: {
      meetingName: "",
      meetingNumber: "",
      meetingYear: "2563",
      meetingDate: "",
      meetingTime: "",
      meetingEndTime: "",
      meetingPlace: "",
      // firstAgenda: "",
      firstAgendaFile: "",
      firstAgendaFilePath: "",
      secondAgenda: "",
      secondAgendaResult: "0",
      secondAgendaFile: "",
      secondAgendaFilePath: "",
      thirdAgenda: "",
      thirdAgendaResult: "0",
      thirdAgendaFile: "",
      thirdAgendaFilePath: "",
      fourthAgendaResult: "0",
      eleventhAgenda: "",
      eleventhAgendaFile: "",
      eleventhAgendaFilePath: "",
      hasSeventh: "0",
      hasEighth: "0",
      hasNinth: "0",
      isSubmit: 0,
      // hours:'',
      // minute:'',
    },
    reviewers: [
      {
        userID: "",
      },
    ],
    reviewersNotJoin: [
      {
        userID: "",
      },
    ],
    reviewersObserver: [
      {
        userID: "",
      },
    ],
    firstAgenda: [
      {
        name: "",
        file: "",
        firstAgenda: "",
        filePath: "",
      },
    ],
    fourthAgenda: [
      {
        hasFourthAgenda: "0",
        researchFourthAgenda: "",
        fourthAgendaDescription: "",
        file: "",
        result: "0",
      },
    ],
    fifthAgenda: [
      {
        meetingID: "",
        file: "",
      },
    ],
    sixthAgenda: [
      {
        hasSixthAgenda: "0",
        researchSixthAgenda: "",
        sixthAgendaDescription: "",
        file: "",
        title: "",
      },
    ],
    seventhAgenda: [
      {
        hasSeventhAgenda: "0",
        researchSeventhAgenda: "",
        seventhAgendaDescription: "",
        file: "",
      },
    ],
    eighthAgenda: [
      {
        hasEighthAgenda: "0",
        researchEighthAgenda: "",
        eighthAgendaDescription: "",
        file: "",
      },
    ],
    ninthAgenda: [
      {
        hasNinthAgenda: "0",
        researchNinthAgenda: "",
        ninthAgendaDescription: "",
        file: "",
      },
    ],
    tenthAgenda: [
      {
        hasTenthAgenda: "0",
        researchTenthAgenda: "",
        tenthAgendaDescription: "",
        file: "",
      },
    ],
    meetingDate: "",
    researchList: [],
    yearsList: [],
    sixthAgendaData: [],
    seventhAgendaData: [],
    eighthAgendaData: [],
    ninthAgendaData: [],
    reviewerList: [],
    reviewersDelete: [],
    genderRatio: {
      male: 0,
      female: 0,
    },
    scientistRatio: {
      scientist: 0,
      non: 0,
    },
    affiliationRatio: {
      affiliation: 0,
      non: 0,
    },
    meetingList: [],
  }),
  beforeDestroy() {
    if (this.refreshIntervalID) clearInterval(this.refreshIntervalID);
  },
  async created() {
    // Check Permission Access
    //  if (this.user.currentRole !== 1 && this.user.currentRole !== 2 && this.user.currentRole !== 4) {
    //      this.$router.go(-1);
    //  }
    this.id = this.$route.query.id;
    await this.getReviewerList();
    await this.getMeet();
    await this.getInitialResearch();
    await this.getMeetingList();
    // this.years();
  },
  methods: {
    updateData(name, val, index = 0) {
      if (name === "reviewers") {
        this.reviewers[index].userID = val;
        this.updateReviewerRatio();
      } else if (name === "firstAgenda") {
        this.firstAgenda[index].firstAgenda = val;
      } else if (name === "reviewersNotJoin") {
        this.reviewersNotJoin[index].userID = val;
      } else if (name === "reviewersObserver") {
        this.reviewersObserver[index].userID = val;
      } else {
        this.form[name] = val;
      }
    },
    getMeetingList() {
      this.$store.dispatch("Meeting/getMeetList").then((res) => {
        res.forEach((data) => {
          this.meetingList.push({
            id: data.id,
            name: data.meetingName + " (" + data.meetingDate + ")",
          });
        });
      });
    },
    updateReviewerRatio() {
      this.genderRatio = {
        male: 0,
        female: 0,
      };
      this.scientistRatio = {
        scientist: 0,
        non: 0,
      };
      this.affiliationRatio = {
        affiliation: 0,
        non: 0,
      };
      this.reviewers.forEach((reviewerData) => {
        let reviewer = this.reviewerList.find(
          (i) => i.user_id == reviewerData.userID
        );
        if (reviewer.gender === 1) this.genderRatio.male += 1;
        else this.genderRatio.female += 1;
        if (reviewer.isScientist === 1) this.scientistRatio.scientist += 1;
        else this.scientistRatio.non += 1;
        if (reviewer.isAffiliated === 1) this.affiliationRatio.affiliation += 1;
        else this.affiliationRatio.non += 1;
      });
    },
    updateDate(name, val) {
      if (name === "meetingDate") {
        this.form.meetingDate = val.date;
        this.meetingDate = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    updateDataFourthAgenda(name, index, val) {
      // console.log('xxx', val)
      this.fourthAgenda[index][name] = val;
    },
    updateDataFifthAgenda(name, index, val) {
      this.fifthAgenda[index][name] = val;
    },
    updateDataSixthAgenda(name, index, val) {
      this.sixthAgenda[index][name] = val;
      if (name === "researchSixthAgenda") {
        this.isLoading = true;
        this.$store
          .dispatch("Research/getResearch", val)
          .then((res) => {
            console.log("research res : ", res.researchCode);

            this.sixthAgendaData[index]["id"] = res.id;
            this.sixthAgendaData[index]["researchCode"] = res.researchCode
              ? res.researchCode
              : "-";
            this.sixthAgendaData[index]["thResearchName"] = res.thResearchName
              ? res.thResearchName
              : "-";
            this.sixthAgendaData[index]["mainResearcherThName"] = res.user
              .preNameTh
              ? res.user.preNameTh + " " + res.user.thName
              : res.user.thName;
            this.sixthAgendaData[index]["approvalDate"] = res.approvalDate
              ? this.changeDate(res.approvalDate)
              : "-";
            this.sixthAgendaData[index]["frequency"] = res.frequency
              ? res.frequency
              : "-";
            this.sixthAgendaData[index]["lastSendDate"] = res.lastSendDate
              ? this.changeDate(res.lastSendDate)
              : "-";
            this.sixthAgendaData[index]["require"] = res.require
              ? res.require
              : "-";
            console.log("sixthAgendaData : ", this.sixthAgendaData);
            this.isLoading = false;
          })
          .catch((e) => {
            this.isLoading = false;
          });
      }
    },
    updateDataSeventhAgenda(name, index, val) {
      this.seventhAgenda[index][name] = val;
      if (name === "researchSeventhAgenda") {
        this.isLoading = true;
        this.$store
          .dispatch("Research/getResearch", val)
          .then((res) => {
            console.log("research res : ", res.researchCode);

            this.seventhAgendaData[index]["id"] = res.id;
            this.seventhAgendaData[index]["researchCode"] = res.researchCode
              ? res.researchCode
              : "-";
            this.seventhAgendaData[index]["thResearchName"] = res.thResearchName
              ? res.thResearchName
              : "-";
            this.seventhAgendaData[index]["mainResearcherThName"] = res.user
              .preNameTh
              ? res.user.preNameTh + " " + res.user.thName
              : res.user.thName;
            this.seventhAgendaData[index]["approvalDate"] = res.approvalDate
              ? this.changeDate(res.approvalDate)
              : "-";
            this.seventhAgendaData[index]["frequency"] = res.frequency
              ? res.frequency
              : "-";
            this.seventhAgendaData[index]["lastSendDate"] = res.lastSendDate
              ? this.changeDate(res.lastSendDate)
              : "-";
            this.seventhAgendaData[index]["require"] = res.require
              ? res.require
              : "-";
            this.isLoading = false;
          })
          .catch((e) => {
            this.isLoading = false;
          });
      }
    },
    updateDataEighthAgenda(name, index, val) {
      this.eighthAgenda[index][name] = val;
      if (name === "researchEighthAgenda") {
        this.isLoading = true;
        this.$store
          .dispatch("Research/getResearch", val)
          .then((res) => {
            console.log("research res : ", res.researchCode);

            this.eighthAgendaData[index]["id"] = res.id;
            this.eighthAgendaData[index]["researchCode"] = res.researchCode
              ? res.researchCode
              : "-";
            this.eighthAgendaData[index]["thResearchName"] = res.thResearchName
              ? res.thResearchName
              : "-";
            this.eighthAgendaData[index]["mainResearcherThName"] = res.user
              .preNameTh
              ? res.user.preNameTh + " " + res.user.thName
              : res.user.thName;
            this.eighthAgendaData[index]["approvalDate"] = res.approvalDate
              ? this.changeDate(res.approvalDate)
              : "-";
            this.eighthAgendaData[index]["frequency"] = res.frequency
              ? res.frequency
              : "-";
            this.eighthAgendaData[index]["lastSendDate"] = res.lastSendDate
              ? this.changeDate(res.lastSendDate)
              : "-";
            this.eighthAgendaData[index]["require"] = res.require
              ? res.require
              : "-";
            this.isLoading = false;
          })
          .catch((e) => {
            this.isLoading = false;
          });
      }
    },
    updateDataNinthAgenda(name, index, val) {
      this.ninthAgenda[index][name] = val;
      if (name === "researchNinthAgenda") {
        this.isLoading = true;
        this.$store
          .dispatch("Research/getResearch", val)
          .then((res) => {
            console.log("research res : ", res.researchCode);

            this.ninthAgendaData[index]["id"] = res.id;
            this.ninthAgendaData[index]["researchCode"] = res.researchCode
              ? res.researchCode
              : "-";
            this.ninthAgendaData[index]["thResearchName"] = res.thResearchName
              ? res.thResearchName
              : "-";
            this.ninthAgendaData[index]["mainResearcherThName"] = res.user
              .preNameTh
              ? res.user.preNameTh + " " + res.user.thName
              : res.user.thName;
            this.ninthAgendaData[index]["approvalDate"] = res.approvalDate
              ? this.changeDate(res.approvalDate)
              : "-";
            this.ninthAgendaData[index]["frequency"] = res.frequency
              ? res.frequency
              : "-";
            this.ninthAgendaData[index]["lastSendDate"] = res.lastSendDate
              ? this.changeDate(res.lastSendDate)
              : "-";
            this.ninthAgendaData[index]["require"] = res.require
              ? res.require
              : "-";
            this.isLoading = false;
          })
          .catch((e) => {
            this.isLoading = false;
          });
      }
    },
    updateDataTenthAgenda(name, index, val) {
      this.tenthAgenda[index][name] = val;
    },
    openPDF() {
      window.open(this.pathResult);
    },
    // get Initial Research List for Selection
    getInitialResearch() {
      this.isLoading = true;
      this.$store
        .dispatch("Research/getInitialResearch")
        .then((res) => {
          this.isLoading = false;
          // console.log('getInitialResearch : ', res)
          res.forEach((data) => {
            this.researchList.push({
              id: data.id,
              name: data.thResearchName,
            });
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    async getMeet() {
      this.isLoading = true;
      this.$store
        .dispatch("Meeting/getMeet", this.id)
        .then(async (res) => {
          // console.log('data', res)
          this.form.meetingName = res.meetingName;
          this.form.hasSeventh = res.hasSeventh;
          this.form.hasEighth = res.hasEighth;
          this.form.hasNinth = res.hasNinth;
          this.form.secondAgendaResult = res.secondAgendaResult;
          this.form.thirdAgendaResult = res.thirdAgendaResult;
          this.form.meetingNumber = res.meetingNumber;
          this.form.meetingYear = res.meetingYear;
          this.form.meetingDate = res.meetingDate;
          this.meetingDate = this.changeDate(res.meetingDate);
          this.form.meetingTime = res.meetingTime;
          this.form.meetingEndTime = res.meetingEndTime;
          this.form.meetingPlace = res.meetingPlace;
          if (typeof res.firstAgenda == "string") {
            if (this.firstAgenda[0]) {
              this.firstAgenda[0].firstAgenda = res.firstAgenda;
              this.firstAgenda[0].file = res.firstAgendaFile;
              this.firstAgenda[0].filePath = res.firstAgendaFilePath;
            }
          } else {
            this.firstAgenda = res.firstAgenda;
          }
          this.form.firstAgendaFile = res.firstAgendaFile;
          this.form.firstAgendaFilePath = res.firstAgendaFilePath;
          this.form.secondAgenda = res.secondAgenda;
          this.form.secondAgendaFile = res.secondAgendaFile;
          this.form.secondAgendaFilePath = res.secondAgendaFilePath;
          this.form.thirdAgenda = res.thirdAgenda;
          this.form.thirdAgendaFile = res.thirdAgendaFile;
          this.form.thirdAgendaFilePath = res.thirdAgendaFilePath;
          this.form.fourthAgendaResult = res.fourthAgendaResult;
          this.form.eleventhAgenda = res.eleventhAgenda;
          this.form.eleventhAgendaFile = res.eleventhAgendaFile;
          this.form.eleventhAgendaFilePath = res.eleventhAgendaFilePath;
          this.fourthAgenda = res.fourthAgenda;
          this.fifthAgenda = res.fifthAgenda;
          this.sixthAgenda = res.sixthAgenda;
          this.seventhAgenda = res.seventhAgenda;
          this.eighthAgenda = res.eighthAgenda;
          this.ninthAgenda = res.ninthAgenda;
          this.tenthAgenda = res.tenthAgenda;
          if (res.sixthAgenda.length > 0) {
            await this.updateResearchData(
              "sixthAgendaData",
              "researchSixthAgenda",
              res.sixthAgenda
            );
          }
          if (res.seventhAgenda.length > 0) {
            await this.updateResearchData(
              "seventhAgendaData",
              "researchSeventhAgenda",
              res.seventhAgenda
            );
          }
          if (res.eighthAgenda.length > 0) {
            await this.updateResearchData(
              "eighthAgendaData",
              "researchEighthAgenda",
              res.eighthAgenda
            );
          }
          if (res.ninthAgenda.length > 0) {
            await this.updateResearchData(
              "ninthAgendaData",
              "researchNinthAgenda",
              res.ninthAgenda
            );
          }
          if (res.reviewers) {
            this.reviewers = await res.reviewers;
          }
          if (res.reviewersNotJoin) {
            this.reviewersNotJoin = await res.reviewersNotJoin;
          }
          if (res.reviewersObserver) {
            this.reviewersObserver = await res.reviewersObserver;
          }
          this.result = res.result;
          this.pathResult = res.pathResult;
          this.isLoading = false;
          this.updateReviewerRatio();
        })
        .catch((e) => {
          console.log("error", e);
          this.isLoading = false;
        });
    },
    update(isSubmit = 0) {
      if (isSubmit) {
        this.isLoading = true;
        if (this.refreshIntervalID) clearInterval(this.refreshIntervalID);
      }
      this.form["firstAgenda"] = this.firstAgenda;
      this.form["fourthAgenda"] = this.fourthAgenda;
      this.form["fifthAgenda"] = this.fifthAgenda;
      this.form["sixthAgenda"] = this.sixthAgenda;
      this.form["seventhAgenda"] = this.seventhAgenda;
      this.form["eighthAgenda"] = this.eighthAgenda;
      this.form["ninthAgenda"] = this.ninthAgenda;
      this.form["tenthAgenda"] = this.tenthAgenda;
      this.form["reviewers"] = this.reviewers;
      this.form["reviewersNotJoin"] = this.reviewersNotJoin;
      this.form["reviewersObserver"] = this.reviewersObserver;
      this.form["reviewersDelete"] = this.reviewersDelete;
      this.form["isSubmit"] = isSubmit;
      this.form["id"] = this.id;
      this.$store
        .dispatch("Meeting/update", this.form)
        .then((res) => {
          console.log("res", res);
          if (isSubmit) {
            Swal.fire({
              title: "บันทึกสำเร็จ",
              icon: "success",
              confirmButtonColor: "#3E7662",
            });
            this.isLoading = false;
            this.$router.push("/meeting");
          } else this.form["id"] = res.id;
        })
        .catch((e) => {
          if (isSubmit) {
            this.isLoading = false;
            if (e.response.data.errors) {
              for (var k in e.response.data.errors) {
                Swal.fire({
                  title: "เกิดข้อผิดพลาด",
                  text: e.response.data.errors[k][0],
                  icon: "warning",
                  confirmButtonColor: "#3E7662",
                }).then(() => {
                  this.$vuetify.goTo(`#${k}`);
                });
              }
            }
          }
        });
    },
    toggleAutoSave() {
      if (this.isAutoSave) {
        //auto save every 10 sec
        this.refreshIntervalID = setInterval(this.update, 10000);
      } else {
        if (this.refreshIntervalID) {
          clearInterval(this.refreshIntervalID);
          this.refreshIntervalID = null;
        }
      }
    },
    async updateResearchData(dataName, agendaName, res) {
      let i = 0;
      for (const data of res) {
        this[dataName].push({
          researchCode: "",
          thResearchName: "",
          mainResearcherThName: "",
          approvalDate: "",
          frequency: "",
          lastSendDate: "",
          require: "",
        });
        if (data[agendaName]) {
          let research_res = await this.$store.dispatch(
            "Research/getResearch",
            data[agendaName]
          );
          this[dataName][i]["id"] = research_res.id ?? "";
          this[dataName][i]["researchCode"] = research_res.researchCode
            ? research_res.researchCode
            : "-";
          this[dataName][i]["thResearchName"] = research_res.thResearchName
            ? research_res.thResearchName
            : "-";
          this[dataName][i]["mainResearcherThName"] = research_res.user
            .preNameTh
            ? research_res.user.preNameTh + " " + research_res.user.thName
            : research_res.user.thName;
          this[dataName][i]["approvalDate"] = research_res.approvalDate
            ? this.changeDate(research_res.approvalDate)
            : "-";
          this[dataName][i]["frequency"] = research_res.frequency
            ? research_res.frequency
            : "-";
          this[dataName][i]["lastSendDate"] = research_res.lastSendDate
            ? this.changeDate(research_res.lastSendDate)
            : "-";
          this[dataName][i]["require"] = research_res.require
            ? research_res.require
            : "-";
          this.isLoading = false;
        }
        i++;
      }
    },
    deleteData() {
      Swal.fire({
        title: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ยืนยันการลบข้อมูล",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("Meeting/delete", this.id)
            .then((res) => {
              this.isLoading = false;
              Swal.fire({
                title: "ลบข้อมูลสำเร็จ",
                icon: "success",
              });
              this.$router.push("/meeting");
            })
            .catch((e) => {
              this.isLoading = false;
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "ลบข้อมูลไม่สำเร็จ",
                icon: "warning",
                confirmButtonColor: "#3E7662",
              });
            });
        }
      });
    },
    clearRedio(name, index) {
      if (name === "hasFourthAgenda") {
        this.fourthAgenda[index].hasFourthAgenda = "0";
        this.fourthAgenda[index].researchFourthAgenda = "";
        this.fourthAgenda[index].fourthAgendaDescription = "";
        this.fourthAgenda[index].file = "";
        this.fourthAgenda[index].result = "";
      }
      if (name === "hasFifthAgenda") {
        this.fifthAgenda[index].meetingID = "0";
        this.fifthAgenda[index].file = "";
      }
      if (name === "hasSixthAgenda") {
        this.sixthAgenda[index].hasSixthAgenda = "0";
        this.sixthAgenda[index].researchSixthAgenda = "";
        this.sixthAgenda[index].sixthAgendaDescription = "";
        this.sixthAgenda[index].file = "";
      }
      if (name === "hasSeventhAgenda") {
        this.seventhAgenda[index].hasSeventhAgenda = "0";
        this.seventhAgenda[index].researchSeventhAgenda = "";
        this.seventhAgenda[index].seventhAgendaDescription = "";
        this.seventhAgenda[index].file = "";
      }
      if (name === "hasEighthAgenda") {
        this.eighthAgenda[index].hasEighthAgenda = "0";
        this.eighthAgenda[index].researchEighthAgenda = "";
        this.eighthAgenda[index].eighthAgendaDescription = "";
        this.eighthAgenda[index].file = "";
      }
      if (name === "hasNinthAgenda") {
        this.ninthAgenda[index].hasNinthAgenda = "0";
        this.ninthAgenda[index].researchNinthAgenda = "";
        this.ninthAgenda[index].ninthAgendaDescription = "";
        this.ninthAgenda[index].file = "";
      }
      if (name === "hasTenthAgenda") {
        this.tenthAgenda[index].hasTenthAgenda = "0";
        this.tenthAgenda[index].researchTenthAgenda = "";
        this.tenthAgenda[index].tenthAgendaDescription = "";
        this.tenthAgenda[index].file = "";
      }
    },
    add(name) {
      if (name === "firstAgenda") {
        this.firstAgenda.push({
          name: "",
          file: "",
          firstAgenda: "",
          filePath: "",
        });
      }
      if (name === "fourthAgenda") {
        this.fourthAgenda.push({
          hasFourthAgenda: "0",
          researchFourthAgenda: "",
          fourthAgendaDescription: "",
          file: "",
          result: "",
        });
      }
      if (name === "fifthAgenda") {
        this.fifthAgenda.push({
          meetingID: "",
          file: "",
        });
      }
      if (name === "sixthAgenda") {
        this.sixthAgenda.push({
          hasSixthAgenda: "0",
          researchSixthAgenda: "",
          sixthAgendaDescription: "",
          file: "",
        });
        this.sixthAgendaData.push({
          researchCode: "",
          thResearchName: "",
          mainResearcherThName: "",
          approvalDate: "",
          frequency: "",
          lastSendDate: "",
          require: "",
        });
      }
      if (name === "seventhAgenda") {
        this.seventhAgenda.push({
          hasSeventhAgenda: "0",
          researchSeventhAgenda: "",
          seventhAgendaDescription: "",
          file: "",
        });
        this.seventhAgendaData.push({
          researchCode: "",
          thResearchName: "",
          mainResearcherThName: "",
          approvalDate: "",
          frequency: "",
          lastSendDate: "",
          require: "",
        });
      }
      if (name === "eighthAgenda") {
        this.eighthAgenda.push({
          hasEighthAgenda: "0",
          researchEighthAgenda: "",
          eighthAgendaDescription: "",
          file: "",
        });
        this.eighthAgendaData.push({
          researchCode: "",
          thResearchName: "",
          mainResearcherThName: "",
          approvalDate: "",
          frequency: "",
          lastSendDate: "",
          require: "",
        });
      }
      if (name === "ninthAgenda") {
        this.ninthAgenda.push({
          hasNinthAgenda: "0",
          researchNinthAgenda: "",
          ninthAgendaDescription: "",
          file: "",
        });
        this.ninthAgendaData.push({
          researchCode: "",
          thResearchName: "",
          mainResearcherThName: "",
          approvalDate: "",
          frequency: "",
          lastSendDate: "",
          require: "",
        });
      }
      if (name === "tenthAgenda") {
        this.tenthAgenda.push({
          hasTenthAgenda: "0",
          researchTenthAgenda: "",
          tenthAgendaDescription: "",
          file: "",
        });
      }
    },
    remove(index, name) {
      if (name === "fourthAgenda") {
        this.fourthAgenda = this.fourthAgenda.filter((item, i) => i !== index);
      }
      if (name === "fifthAgenda") {
        this.fifthAgenda = this.fifthAgenda.filter((item, i) => i !== index);
      }
      if (name === "sixthAgenda") {
        this.sixthAgenda = this.sixthAgenda.filter((item, i) => i !== index);
      }
      if (name === "seventhAgenda") {
        this.seventhAgenda = this.seventhAgenda.filter(
          (item, i) => i !== index
        );
      }
      if (name === "eighthAgenda") {
        this.eighthAgenda = this.eighthAgenda.filter((item, i) => i !== index);
      }
      if (name === "ninthAgenda") {
        this.ninthAgenda = this.ninthAgenda.filter((item, i) => i !== index);
      }
      if (name === "tenthAgenda") {
        this.tenthAgenda = this.tenthAgenda.filter((item, i) => i !== index);
      }
      if (name === "firstAgenda") {
        this.firstAgenda = this.firstAgenda.filter((item, i) => i !== index);
      }
    },
    addReviewer(name, index) {
      this[name].push({ userID: "" });
      this.indexArr = parseInt(this.indexArr) + index;
    },
    getReviewerList() {
      this.isLoading = true;
      this.$store
        .dispatch("User/getReviewerList")
        .then((res) => {
          this.isLoading = false;
          console.log("getReviewerList : ", res);
          res.forEach((data) => {
            this.reviewerList.push({
              user_id: data.id,
              user_name: data.thName,
              gender: data.gender,
              isScientist: data.isScientist,
              isAffiliated: data.isAffiliated,
              affiliation: data.affiliation,
            });
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    removeReviewer(name, index) {
      var objs = {};
      // console.log(this.reviewers.splice(index, 1));
      objs = this[name].splice(index, 1);
      if (name === "reviewers") {
        objs.forEach((obj) => {
          this.reviewersDelete.push(obj);
        });
        this.updateReviewerRatio();
      }
      this.indexArr = parseInt(this.indexArr) - 1;
    },
    onUploadFile(val, e) {
      if (e && e !== "undefined") this.isLoading = true;
      this.$store
        .dispatch("Common/onUploadFileMeet", { name: val, file: e })
        .then((res) => {
          this.form[val] = res.fileName;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
    },
    onUploadFileDynamic(val, index, e) {
      if (e && e !== "undefined") this.isLoading = true;
      this.$store
        .dispatch("Common/onUploadFileMeet", { name: val, file: e })
        .then((res) => {
          if (val == "firstAgendaFile") {
            this.firstAgenda[index].file = res.fileName;
          } else {
            this[val][index].file = res.fileName;
          }
          this.isLoading = false;
          console.log(this.firstAgenda);
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
      console.log(val, index, this[val][index]);
    },
    onHandleBtn(index) {
      document.getElementById(index).click();
    },
  },
};
</script>

<style lang="scss">
.vue__time-picker input.display-time {
  background-color: #3e7662;
  color: white;
  border: 1px solid #d2d2d2;
  width: 10em;
  height: 2.2em;
  padding: 0.3em 0.5em;
  font-size: 1em;
}
</style>
